// Legacy Privacy-Manager taxonomies for the Bedreigingen + Bedrijfsmiddelen registers (LEGACY-AUDIT T2/T3).
// The legacy presents class/category/likelihood/vulnerability as catalog-backed DROPDOWNS, not free text.
// These option lists reproduce the captured legacy taxonomy so the create/edit forms are selectable. (A
// future admin-managed catalog — Phase E canonical libraries — would replace these constants with tenant
// data; until then these constants are the catalog.) value === label so the stored text stays human-readable.
type Opt = { value: string; label: string };
const opts = (...labels: string[]): Opt[] => labels.map((l) => ({ value: l, label: l }));

// 6-point ordinal scales (verbatim from the legacy create forms).
export const PROBABILITY_6: Opt[] = opts(
  "Geen", "Zeer onwaarschijnlijk", "Onwaarschijnlijk", "Waarschijnlijk", "Zeer waarschijnlijk", "Zeker",
);
export const VULNERABILITY_6: Opt[] = opts(
  "Geen", "Zeer laag", "Laag", "Gemiddeld", "Hoog", "Kritiek",
);
// Risk-register likelihood ("Kans") — kept compatible with the existing low|medium|high|very_high vocabulary.
export const LIKELIHOOD: Opt[] = [
  { value: "low", label: "Laag" }, { value: "medium", label: "Middel" },
  { value: "high", label: "Hoog" }, { value: "very_high", label: "Zeer hoog" },
];

// Bedreigingscategorieën (captured legacy set + common GDPR/security threat categories).
export const THREAT_CATEGORIES: Opt[] = opts(
  "AI-specifieke dreigingen", "Authenticatiefalen", "Autorisatiefalen", "Back-up- en herstelfalen",
  "Bewuste interne misbruikdreiging (insider threat)", "Compliance-falen", "Configuratiefouten",
  "Continuïteitsfalen", "Contractueel/governance-falen", "Databeschikbaarheidsverlies",
  "Datalek / ongeautoriseerde openbaarmaking", "Fysieke dreigingen", "Malware / ransomware",
  "Menselijke fout", "Phishing / social engineering", "Verlies of diefstal van apparatuur",
);
// Bedreigingsklassen — the BIV/AVG impact dimension a threat primarily affects.
export const THREAT_CLASSES: Opt[] = opts(
  "Vertrouwelijkheid", "Integriteit", "Beschikbaarheid", "Grondrechten betrokkenen",
);

// Bedrijfsmiddelcategorieën (captured legacy set).
export const ASSET_CATEGORIES: Opt[] = opts(
  "Applicaties & systemen", "Beleidsdocumenten", "Beveiligingsvoorzieningen", "Continuïteitsvoorzieningen",
  "Contractuele afspraken", "Data & informatie", "Fysieke locaties", "Gegevensdragers", "Hardware",
  "Netwerkvoorzieningen", "Personen & rollen", "Software",
);
// Bedrijfsmiddelklassen (captured legacy "Applicaties & systemen" classes + common ones).
export const ASSET_CLASSES: Opt[] = opts(
  "AI-systemen", "Beveiligingsapplicaties", "Communicatieplatformen", "CRM-systemen", "Databasesystemen",
  "Financiële applicaties", "HRM-systemen", "Identiteits- en toegangsbeheer (IAM)",
  "Integratieplatformen / API-gateways", "Kantoorautomatisering", "Opslag & back-up", "Websites & portalen",
);
